import React from "react"
import { Helmet } from "react-helmet"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Container, Section, SectionHead } from "src/components/common"
import { List } from "./styles"

export const Faq = () => {
  const { t } = useTranslation()
  const items = t("faq:items", { returnObjects: true })
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map(item => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  }

  return (
    <Section id="faq" aria-labelledby="faq-title" $tone="soft">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <Container>
        <SectionHead
          id="faq-title"
          title={t("faq:headline")}
          lead={t("faq:lead")}
        />
        <List>
          {items.map((item, index) => (
            <details key={index}>
              <summary>
                <h3>{item.q}</h3>
              </summary>
              <p>{item.a}</p>
            </details>
          ))}
        </List>
      </Container>
    </Section>
  )
}
